import styled from "styled-components";
import { Marquee } from "../ui/animations";
const TilesContainer = styled.div`
  width: 100vw;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 10;
  height: 100vh;
  overflow: hidden;
  box-sizing: border-box;
  display: flex;
  .svg--wrapper {
    margin-top: 5rem;
    position: relative;
    svg {
      position: absolute;
      animation: ${Marquee} 33.75s linear infinite;
      top: ${({ svgTop }) => svgTop || "20%"};
    }
  }
`;

export default TilesContainer;
